export class SelfMaintenance {

    // eslint-disable-next-line max-params
    constructor(
        readonly enable: boolean,
        readonly startMaintenance: string,
        readonly enableRemoveLogs: boolean,
        readonly daysKeepLogs: number,
        readonly enableRemoveData: boolean,
        readonly daysKeepData: number,
        readonly enableRemoveJobs: boolean,
        readonly daysKeepJobs: number
    ) { }

}